module.exports = __webpack_public_path__ + "img/Logo_IC_Outubro_Rosa.763e2a6b.png";